import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import services from '../../services';

import { useDispatch } from "react-redux"
import { showMsgE as showMsgEAction} from '../../store/actions/snackbarActions.js';

const BannerCard = ({ usuario, update, setLoading }) => {

    const dispatch = useDispatch();
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));

    const history = useHistory();

    const apagar = async (id) => {
        try{
            setLoading(true)
            await services.apiAuto.deleteBanner(id)
            await update()
        } catch(e){
            showMsgE(e.response.data)
        } finally{
            setLoading(false)
        }
    }
    
    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Nome:
            </div>
            <div className={styles.info}>
                {usuario.nome}
            </div>
            <div className={styles.title}>
                Tipo:
            </div>
            <div className={styles.info}>
                {usuario.tipoBannerDescricao}
            </div>
            <div className={styles.title}>
                Ordem
            </div>
            <div className={styles.info}>
                { usuario.ordem }
            </div>
            <div className={styles.actionWrapper}>

                { usuario.status === 1 && (<div className={styles.andamento}>ATIVO</div>) }
                { usuario.status === 0 && (<div className={styles.encerrado}>INATIVO</div>) }
                <button className={styles.editar} onClick={() => { apagar(usuario.id) }}>
                    Inativar
                    <FontAwesomeIcon icon={faTimes} className={styles.icon}/>
                </button>
                <button className={styles.editar} onClick={() => {history.push(`/banner/detalhes?banner=${usuario.id}`)}}>
                    Editar
                    <FontAwesomeIcon icon={faUpload} className={styles.icon}/>
                </button>
            </div>
        </div>
    )
}

export default BannerCard